
import "./internal.css";
import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, doc, setDoc, addDoc } from "firebase/firestore";

export default function Details() {

    async function criar_plano(data) {
        try {
            let dt = new Date();

            const plandoc = await addDoc(collection(db, "plans"), { 
                codigo: "EST1",
                ramo: "Esteticistas",
                atendimento: "W",
                valor: 6,
                data_criacao: dt,
                data_inicio_vigencia: dt,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            });

            console.log("Plano criado");
        } catch (erro) {
            console.log(erro);
        }
    }

    function gerarHorarioAleatorio(livreChance = 0.7) {
        const livre = Math.random() < livreChance;
        if (livre) return { livre: true };
        return {
            livre: false,
            paciente: {
                nome: `Paciente ${Math.floor(Math.random() * 100)}`,
                email: `paciente${Math.floor(Math.random() * 100)}@teste.com`,
                telefone: `(11) 9${Math.floor(1000 + Math.random() * 9000)}-${Math.floor(1000 + Math.random() * 9000)}`,
                metadata: ["Amil", "Bradesco", "Unimed"][Math.floor(Math.random() * 3)]
            }
        };
    }


    async function criar_agenda() {
        const agentId = "3E364B1A0A99507FF12A023103FD214D";
        const interval = 60;
        const horariosPadrao = ["08:00", "09:00", "10:00", "11:00", "12:00"];

        const numDias = 30; // quantidade de dias que queremos gerar
        const hoje = new Date();

        for (let i = 0; i < numDias; i++) {
            const diaObj = new Date(hoje);
            diaObj.setDate(hoje.getDate() + i);

            const diaDoc = diaObj.toISOString().slice(0,10).replace(/-/g,""); // YYYYMMDD

            const blockedDay = Math.random() < 0.1; // 10% de chance de dia bloqueado
            const blockedReason = blockedDay ? "Feriado / indisponível" : "";

            const horariosMap = {};
            for (let h of horariosPadrao) {
                horariosMap[h] = blockedDay ? { livre: false } : gerarHorarioAleatorio();
            }

            const diaData = {
                interval,
                blocked_day: blockedDay,
                blocked_reason: blockedReason,
                horarios: horariosMap,
                updated_at: new Date("2100-12-31T23:59:59Z")
            };

            try {
                await setDoc(doc(db, "calendar", agentId, "dias", diaDoc), diaData);
                console.log(`Dia ${diaDoc} criado com sucesso!`);
            } catch (erro) {
                console.log(`Erro ao criar dia ${diaDoc}:`, erro);
            }
        }

        console.log("Agenda de teste gerada com sucesso!");
    }


    return(
        <div>
            <span>Para criar um plano</span>
            <br /><br />
            <div><button input="button" onClick={criar_plano}>Criar Plano</button></div>
            <br /><br />
            <span>Para criar uma agenda de testes</span>
            <br /><br />
            <div><button input="button" onClick={criar_agenda}>Criar Agenda Teste</button></div>
        </div>
    )
}
